export default "__VITE_ASSET__DctlE1dy__"